// ⚠️ 自動生成 (scripts/build_player_attack_frames.py)。手で直さない。
// 主人公の連撃の描いたコマ: 段ごとに [表示し始める ms, 次へ移る ms, 左端の x, 上端の y, 幅, 高さ] (表示 px・前向き = +x・足の裏 = y 0)。
//   x は「段の始めの体の位置」から測る。3段目は描画時にゲームの踏み込み量を引く。
export type PlayerAttackFrame = { name: string, fromMs: number, untilMs: number, dx: number, dy: number, w: number, h: number }
export const PLAYER_ATTACK_FRAMES: readonly (readonly PlayerAttackFrame[])[] = [
  [
    {
      "name": "s1_2",
      "fromMs": 0,
      "untilMs": 40,
      "dx": -38.14,
      "dy": -119.68,
      "w": 96.38,
      "h": 119.68
    },
    {
      "name": "s1_3",
      "fromMs": 40,
      "untilMs": 60,
      "dx": -30.16,
      "dy": -119.36,
      "w": 97.98,
      "h": 118.09
    },
    {
      "name": "s1_4",
      "fromMs": 60,
      "untilMs": 140,
      "dx": -29.84,
      "dy": -105.96,
      "w": 148.72,
      "h": 105.32
    },
    {
      "name": "s1_5",
      "fromMs": 140,
      "untilMs": 230,
      "dx": -25.05,
      "dy": -105.0,
      "w": 141.7,
      "h": 103.4
    },
    {
      "name": "s1_6",
      "fromMs": 230,
      "untilMs": 400,
      "dx": -34.95,
      "dy": -120.0,
      "w": 83.3,
      "h": 120.32
    }
  ],
  [
    {
      "name": "s2_1",
      "fromMs": 0,
      "untilMs": 25,
      "dx": -34.32,
      "dy": -120.0,
      "w": 112.09,
      "h": 120.0
    },
    {
      "name": "s2_2",
      "fromMs": 25,
      "untilMs": 50,
      "dx": -33.8,
      "dy": -108.66,
      "w": 99.16,
      "h": 108.66
    },
    {
      "name": "s2_3",
      "fromMs": 50,
      "untilMs": 65,
      "dx": -38.02,
      "dy": -105.49,
      "w": 117.36,
      "h": 105.49
    },
    {
      "name": "s2_4",
      "fromMs": 65,
      "untilMs": 230,
      "dx": -29.84,
      "dy": -98.9,
      "w": 167.47,
      "h": 99.16
    },
    {
      "name": "s2_5",
      "fromMs": 230,
      "untilMs": 400,
      "dx": -36.66,
      "dy": -120.26,
      "w": 98.64,
      "h": 120.26
    }
  ],
  [
    {
      "name": "s3a_2",
      "fromMs": 0,
      "untilMs": 55,
      "dx": -53.61,
      "dy": -139.42,
      "w": 104.93,
      "h": 139.71
    },
    {
      "name": "s3a_3",
      "fromMs": 55,
      "untilMs": 75,
      "dx": -31.0,
      "dy": -113.91,
      "w": 159.13,
      "h": 106.38
    },
    {
      "name": "s3a_4",
      "fromMs": 75,
      "untilMs": 180,
      "dx": -29.84,
      "dy": -100.0,
      "w": 200.0,
      "h": 99.71
    },
    {
      "name": "s3b_2",
      "fromMs": 180,
      "untilMs": 320,
      "dx": -22.14,
      "dy": -100.93,
      "w": 197.75,
      "h": 100.34
    },
    {
      "name": "s3b_3",
      "fromMs": 320,
      "untilMs": 420,
      "dx": 28.03,
      "dy": -109.73,
      "w": 150.22,
      "h": 109.73
    },
    {
      "name": "s3b_4",
      "fromMs": 420,
      "untilMs": 520,
      "dx": 1.53,
      "dy": -119.12,
      "w": 103.28,
      "h": 120.0
    }
  ]
]
